module.exports = __webpack_public_path__ + "static/media/icon_default_image_disabled.a97d5ea9.png";